'use client';
import { styled } from '@mui/material/styles';
import { NavItemButton } from '../NavItemButton';
export const StyledNavItemButton = styled(NavItemButton)(({ theme }) => ({
    '&.MuiButton-root': {
        fontSize: theme.tokens.FuelFontSizeBase,
        padding: `${theme.tokens.FuelSpacing2} ${theme.tokens.FuelSpacing4}`,
        height: theme.tokens.FuelSpacing12,
        '& .FuelNavItemButton-text': {
            lineHeight: theme.tokens.FuelLineHeightBase,
            paddingRight: theme.tokens.FuelSpacing4
        }
    }
}));
